module.exports = __webpack_public_path__ + "img/KK0041C-IL.7e34163b.jpg";